import { WorkspaceViewArticleItem } from '@/@types/WorkspaceViewArticleItem';
import store from '@/store';
import { Article } from '@/models/article/Article';

export const commitSetSelectedArticle = (article: Article) => {
  store.commit('setWorkspaceViewSelectedArticle', article);
};

export const commitWorkspaceViewSetActiveTextTabId = (textTabId: string | null) => {
  store.commit('setWorkspaceViewActiveTextTabId', textTabId);
};

export const commitSetWorkspaceViewArticles = (articles: WorkspaceViewArticleItem[]) => {
  store.commit('setWorkspaceViewArticles', articles);
};

export const commitWorkspaceViewReset = () => {
  store.commit('resetWorkspaceView');
};

export const commitSetWorkspaceViewCommentsCount = (count = 0) => {
  store.commit('setWorkspaceView', ['commentsCount', count]);
};
